import NotificationsSection from '@/components/user/settings/notifications/notifications-section';
import AccountSettingsPageShell from './AccountSettingsPageShell';

const AccountNotificationsSettingsPage = () => {
  return (
    <AccountSettingsPageShell titleKey="settings.accountNav.notifications">
      <NotificationsSection />
    </AccountSettingsPageShell>
  );
};

export default AccountNotificationsSettingsPage;
